import { type IconType, Loader, QueryBoundary } from '@outdoria/ui';
import { useGetItemTypesAll } from '@outdoria/api';
import { SelectEntityButton } from '../../components';

import s from './ItemCreateSelectTypeView.module.scss';

export const ItemCreateSelectTypeView = () => (
  <QueryBoundary fallback={<Loader />}>
    <Load />
  </QueryBoundary>
);

const Load = () => {
  const { data: itemTypes } = useGetItemTypesAll();
  const DISABLED_ITEM_TYPES = ['equipment', 'consumable'];

  return (
    <div className={s.view}>
      {itemTypes.map(itemType => (
        <SelectEntityButton
          key={itemType.name}
          description={itemType.description}
          icon={itemType.icon as IconType}
          link={itemType.item_type_id}
          title={itemType.name}
          isDisabled={DISABLED_ITEM_TYPES.includes(itemType.item_type_id)}
        />
      ))}
    </div>
  );
};
